export default __webpack_public_path__ + "static/media/icon10.a02d54f7.svg";